export const environment = {
   production: true,
   hmr: false,
   apiUrl: 'https://kdm-api.cineline.pl/',
   version: '1.0.0' 
};
